export default {
  cnpjs: [],
  cnpj: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
